import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=58a8df2c&scoped=true"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=58a8df2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8df2c",
  null
  
)

export default component.exports